<template>
  <div class="pageloader is-active">
    <span class="title has-text-white">
      Verificando token...
    </span>
  </div>
</template>

<script>
export default {
  name: 'VerifyAutoInvoiceToken',
  async mounted() {
    const router = this.$router;
    const route = this.$route;

    if (!route.query.token) router.push({ name: 'Landing' });

    const { invoiceId } = await this.$store.dispatch(
      'invoice/verifyAutoInvoiceToken',
      route.query.token,
    );

    router.push({
      name: 'AutoInvoiceDetail',
      params: { id: invoiceId },
    });
  },
};
</script>
